'use client';

import { SignInHeader } from '@/components/layouts/signin/SignInHeader';
import { SigninBox } from '@/features/account/SigninBox';
import { useLogic } from './logic';

type Props = {
  proxyToken?: string;
  isAdmin?: boolean;
};

export function SigninPage({ proxyToken, isAdmin }: Props) {
  useLogic({ proxyToken, isAdmin });

  return (
    <>
      <SignInHeader />
      <SigninBox />
    </>
  );
}
